export const SITE_URL = {url: 'http://localhost:3000'};
export const API_URL = {url: '/api'};
